<template>
  <div class="container" v-cloak>
    <div class="inner-center">
      <div class="header">
        <div class="title">
          营销日历 • {{ dateStrArr[0] }}年{{ dateStrArr[1] }}月
        </div>
        <div class="btn">
          <i class="iconfont icon-a-arrowright icon_arrowleft" @click="prevMonth"/>
          <span @click="initDate">今天</span>
          <i class="iconfont icon-a-arrowright" @click="nextMonth"/>
        </div>
      </div>
      <div class="calendar-card" v-if="calendarData.length">
        <!-- 活动导航 -->
        <div class="act-nav-box">
          <div class="act-nav">
            <div
              class="act-item _pointer"
              @click="toggleChecked(vo)"
              v-for="vo in nav" :key="vo.type"
              :style="{'color': vo.checked ? vo.color : '' }"
            >
              <i
                class="iconfont"
                :class=" [vo.checked ? 'icon-checkbox' : 'icon-checkbox2' ] "
                :style=" [ 'color:' + vo.checked ? vo.color : '' ] "
              />
              {{ vo.val }}
            </div>
          </div>
<!--          v-if="isVip"-->
          <div class="add-schedule"
               @click="showCustomScheduleModalByBtn"

          >
            <i class="icon_copyright"/>
            添加日程
          </div>
        </div>


        <div class="calendar-box">
          <div class="calendar-nav ">
            <div class="calendar-item" v-for="vo in [
              '周日',
              '周一',
              '周二',
              '周三',
              '周四',
              '周五',
              '周六',
            ]">
              {{ vo }}

            </div>
          </div>
          <div class="calendar-body">
            <!-- 前置空格 -->
            <div class="calendar-item" v-for="(vo,idx) in preCalendar" :key=" 'pre'+ idx "/>

            <div
              v-for="(vo,idx) in calendarData"
              :key=" 'cal'+ idx "
              :class="[ {'on': currDay === vo.day} ]"
              class="calendar-item"
              @click="showCustomScheduleModalByCalendarItem(vo)"
            >
              <div class="header">
                <!-- v-if="vo.holidaysCN.name || vo.solarTerm || vo.lunar" -->
                <span class="txt-lunar">
                  {{ vo.lunar }}
                  <span class="txt-rest" v-if="vo.isRest">休</span>
                  <span class="txt-rest txt-rest-work" v-if="vo.isWork">班</span>
                </span>
                <div class="txt-date " :class="[ {'on': currDay === vo.day} ]">
                  {{ vo.day }}
                </div>
              </div>
              <div class="act-list">
                <template v-if="vo.actData.length">
                  <!-- <transition-group appear > -->
                  <div
                    v-for="itm in vo.actData"
                    :key="itm.title"
                    :style="
                      'color: ' + nav[itm.type-1].color,
                      'background: ' + nav[itm.type-1].hoverColor
                    "
                    class="act-item "
                    :class=" 'act-item'+itm.type "
                    @click.stop=""
                  >
                    <div
                      :style="'background: ' + nav[itm.type-1].color "
                      class="bar "/>
                    <div
                      class="act-text overflow-one"
                      :style="'color: ' + nav[itm.type-1].color">

                      <a :href="itm.link_url" target="_blank" @click.stop="setStat(itm.type)" v-if="!!itm.link_url">
                        <span><i class="iconfont icon-copylink"/>{{ itm.title }}</span>
                      </a>

                      <span v-else>
                        <span v-if="itm.type != 6" @click.stop="">{{ itm.title }}</span>
                        <span v-else
                              @click="showCustomScheduleModalByItem({itm,vo,idx})"
                        >
                          <i :class="'reminder-type-item'+ itm.icon "></i>
                          {{ itm.title }}
                        </span>
                      </span>
                    </div>
                    <div class="act-hover-text" v-if="itm.title && itm.title.length > 10">{{ itm.title }}</div>
                  </div>
                  <!--                  </transition-group>-->
                </template>

              </div>

              <CustomScheduleModal class="CustomScheduleModal"
                                   :calendar-item="vo"
                                   :formData="formData"
                                   :currDate="currDate"
                                   @closeCustomScheduleModal="closeCustomScheduleModal"
                                   @deleteCustomSchedule="deleteCustomSchedule"
                                   @saveCustomSchedule="saveCustomSchedule"
              />

            </div>
            <!-- 后置空格 -->
            <div class="calendar-item" v-for="(vo,idx) in nextCalendar" :key=" 'next'+ idx "/>
          </div>
        </div>
      </div>
    </div>


    <!-- 非VIP 提示 -->
    <div class="no-vip" v-if="showNoVipModal">
      <ModalMiddle @close="showNoVipModal = false">
        <div slot="ModalContent" class="ModalContent">
          <div class="desc">
            潮国创意—宠粉增值服务 <br>
            自定义日程仅对VIP开放
          </div>
<!--          @click="showNoVipModal = false"-->

          <a :href="PAY_BUSINESS" target="_blank" class="btn"
             @click="openVip"
          >
            开通会员
          </a>
        </div>
      </ModalMiddle>
    </div>

  </div>
</template>

<script>
import Calendar from '@/utils/Calendar'
import {nav, list, HEADER} from './module'
import {deleteCalendarCustomSchedule, getCalendar, setCalendarCustomSchedule, statCalendar} from "@/api/calendar";
import {fnFlowStatistics, fnLayout, fnLogin} from "@/fn";
import {toolDate} from "@/tools";
import CustomScheduleModal from "@/components/_Privately/Calendar/CustomScheduleModal";
import {checkUserIsVipNew} from "@/fn/_Privately/User";
import {PAY_BUSINESS} from "@/constant/_Public/Path";
import {mapState} from "vuex";
import {tag} from "@/utils/statUtil";


export default {
  name: "MarketingCalendar",
  layout: "header-nav",
  head() {
    return HEADER;
  },
  components: {
    CustomScheduleModal
  },
  data() {
    return {
      PAY_BUSINESS,
      nav,
      list,
      currMonth: 0,
      currDay: 0,
      calendarData: [],

      currDate: {
        year: '',
        month: '',
        day: '',
        type: 0
      },
      preCalendar: 0,
      nextCalendar: 0,
      /* 活动条样式 */
      actBar: {},
      /* 当天日期 */
      initCurrDate: {},
      /* 动态日期 */
      changeDate: '',
      dateStrArr: [],
      nDate: 0,  //
      isVip: false,
      formData: {},
      showNoVipModal: false,

    }
  },
  mounted() {
    this.initDate();
    this.init();
  },
  computed: {
    ...mapState('user', ['isLogin', 'name', 'avatar']),
  },
  watch: {
    currDate: { //监听的对象
      deep: true, //深度监听设置为 true
      handler: function (newV, oldV) {
        this.currDay = (newV.month == this.currMonth) ? this.currDate.day : 0
        // this.currDay = this.currDate.day
      }
    },
    isLogin: {
      handler(n, o) {
        if (n == true || n == false) {
          this.initDate();
          this.init();
        }
      },
    },
  },

  methods: {
    init() {
      this.checkUserIsVipNew();
      fnLayout.setFooterBgColor();
      fnFlowStatistics.pageFlow('calendar');
      this.statCalendar(1);
    },

    async statCalendar(type){
      await statCalendar({type})
    },

    setStat(type){
      console.log(type)
      let findItem = nav.find(item => item.type == type)
      if (findItem != undefined){
        this.statCalendar(findItem.statType);
      }

    },

    async checkUserIsVipNew() {
      this.isVip = await checkUserIsVipNew();
      console.log(this.isVip)

    },

    showCustomScheduleModalByBtn() {

      if (!fnLogin.checkLogin()) {
        this.$myNotify.show('请先登录');
        return false;
      }

      if (!this.isVip) {
        // this.$myNotify.show('');
        this.showNoVipModal = true;
        return false;
      }


      this.formData = {};
      let findItem = this.calendarData.find(item => item.day == this.currDay);
      console.log(findItem)
      if (findItem != undefined) {
        // this.showCustomScheduleModal(findItem)
        this.showCustomScheduleModalByCalendarItem(findItem)
      }
    },

    showCustomScheduleModalByCalendarItem(vo) {
      console.log(vo)
      this.formData = {};
      this.showCustomScheduleModal(vo)
    },

    showCustomScheduleModalByItem(info) {
      console.log({
        info
      })
      const {itm, vo, idx} = info
      this.formData = itm
      /* 填充表单信息 */
      this.showCustomScheduleModal(vo);
    },


    showCustomScheduleModal(vo) {

      if (!this.isVip) {
        // this.$myNotify.show('');
        this.showNoVipModal = true;
        return false;
      }


      if (vo.showCustomScheduleModal) {
        return
      }

      /* 清除其他的日程弹框 */
      this.calendarData.forEach(item => item.showCustomScheduleModal = false);

      console.log(11111111)
      console.log(vo)
      vo.showCustomScheduleModal = true;

    },

    closeCustomScheduleModal(vo) {
      vo.showCustomScheduleModal = false;
      setTimeout(() => {
      }, 300)
    },

    deleteCustomSchedule(params) {
      console.log(params)
      console.log(this.formData)
      const {custom_id = 0,start_date='',end_date=''} = this.formData
      const {startTime='',endTime=''} = params;
      deleteCalendarCustomSchedule({
        customId: custom_id,
        startTime,
        endTime,
      }).then(res => {
        const {status, message, data} = res.data;
        if (status == 200) {
          this.$myNotify.show(message, () => {
            let tempDateStrArr = this.changeDate.split('-')
            this.dateStrArr = tempDateStrArr;
            this.initMonthData(`${tempDateStrArr[0]}-${tempDateStrArr[1]}-${tempDateStrArr[2]}`)
          });
        } else {
          this.$myNotify.error(message)
        }
      })
    },

    saveCustomSchedule(params) {

      setCalendarCustomSchedule(params).then(res => {
        console.log(res)
        const {status, message, data} = res.data;
        if (status == 200) {
          this.$myNotify.show(message, () => {
            let tempDateStrArr = this.changeDate.split('-')
            this.dateStrArr = tempDateStrArr;
            // console.log(tempDateStrArr)
            this.initMonthData(`${tempDateStrArr[0]}-${tempDateStrArr[1]}-${tempDateStrArr[2]}`)
          });
        } else {
          this.$myNotify.error(message)
        }
      })
    },

    toggleDay(day) {
      this.currDay = day
    },

    initDate() {
      let nav = this.$localStorage.getItem('navNew3')
      if (nav != null) {
        this.nav = JSON.parse(this.$localStorage.getItem('navNew3'))
      }
      const date = Calendar.getDate();
      this.initCurrDate = date;
      this.dateStrArr = date.date.split('-')
      this.nDate = 0; // 初始化
      this.currDate = {...this.currDate, ...date};
      this.currMonth = date.month;
      this.changeDate = date.date


      this.initMonthData();
    },

    initMonthData(dateStr) {
      /* 根据年月获取对应月份的日期 */
      // const currDate = dateStr == undefined ? Calendar.getDate() : Calendar.getDate(dateStr);
      let currDate = toolDate.getDate(dateStr)
      const {year, month, day} = currDate;
      /* 获取基本数据格式 */
      let {dateData, preDays, nextDays} = Calendar.getCalenderData(year, month);

      dateData.forEach(vo => vo.showCustomScheduleModal = false);
      this.calendarData = dateData;
      this.preCalendar = preDays;
      this.nextCalendar = nextDays;
      let typeStr = this.initType();
      this.getCalendar(typeStr);

    },

    initType() {
      let type = [];
      this.nav.map(item => {
        if (item.checked) {
          type.push(item.type)
        }
      });
      let typeStr = type.join(",");
      return typeStr;
    },

    getCalendar(typeStr) {
      getCalendar({
        year: this.dateStrArr[0],  // 年份不变
        // year: this.initCurrDate.year,
        month: this.dateStrArr[1],
        type: typeStr
      }).then(res => {
        const {status, act, holiday, workday} = res.data;
        let _calendarData = this.calendarData

        if (status === 1) {
          _calendarData.forEach((vo, idx) => {
            if (Array.isArray(holiday) && holiday.length > 0) {
              vo.isRest = holiday.indexOf(vo.fillZeroDate) > -1;
            }
            if (Array.isArray(workday) && workday.length > 0) {
              vo.isWork = workday.indexOf(vo.fillZeroDate) > -1;
            }
            if (JSON.stringify(act) !== "{}") {
              for (const key in act) {
                console.log({act})
                console.log(vo.fillZeroDate)
                if (vo.fillZeroDate === key) {
                  vo.actData = vo.actData.concat(act[key]);
                  // vo.actData = act[key];
                  // vo.actData.push(act[key])
                }
              }
            }
            this.$set(this.calendarData, idx, vo)
          })

        }

      })
    },


    nextMonth() {
      let tempNextMonth = this.getNextMonth(this.changeDate);
      this.nDate += 1;
      if (this.nDate > 6) {
        this.nDate = 6
        this.$myNotify.show('到底了');
        return;
      } else {
        this.changeDate = tempNextMonth;
        let tempDateStrArr = this.changeDate.split('-')
        this.dateStrArr = tempDateStrArr;
        // console.log(tempDateStrArr)
        this.initMonthData(`${tempDateStrArr[0]}-${tempDateStrArr[1]}-${tempDateStrArr[2]}`)
      }
    },

    reduMonths(startMonth, endMonth) {
      let startY = startMonth.split("-")[0],
        startM = startMonth.split("-")[1],
        endY = endMonth.split("-")[0],
        endM = endMonth.split("-")[1];
      startMonth = startY + startM
      endMonth = endY + endM
      if (startMonth > endMonth) {
        let reduY = startY - endY,
          reduM = startM - endM;
        // return reduY*12+reduM + "个月"
        return reduY * 12 + reduM
      } else if (startMonth < endMonth) {
        let reduY = endY - startY,
          reduM = endM - startM;

        // return reduY*12+reduM + "个月"
        return reduY * 12 + reduM
      } else {
        return 0
      }
    },

    //mons是比较的月数,如 2019-02-01 14:27:08 - 2019-08-01 14:27:08
    compareTime(mons, stTime, endTime) {
      var st = new Date(stTime);
      var et = new Date(endTime);
      var st6mon = new Date(st);
      st6mon.setMonth(st6mon.getMonth() + mons);

      if (et.getTime() > st6mon.getTime()) {
        //末位时间超时起始时间6个月　　　　return true;
      }
      return false;
      //ps:可以用 if(et >(或<) st6mon)，但比较if(et==st6mon)永远返回false，可能==返回的是对象地址引用，所以用getTime()
    },

    prevMonth() {
      let tempNextMonth = this.getPreMonth(this.changeDate);
      this.nDate -= 1;
      console.log(tempNextMonth)
      console.log(this.reduMonths(this.changeDate, this.initCurrDate.date))
      if (this.nDate < -5) {
        console.log('<到底了')
        this.nDate = -5
        this.$myNotify.show('到底了');
        return;
      } else {
        this.changeDate = tempNextMonth;
        let tempDateStrArr = this.changeDate.split('-')
        this.dateStrArr = tempDateStrArr;
        this.initMonthData(`${tempDateStrArr[0]}-${tempDateStrArr[1]}-${tempDateStrArr[2]}`)
      }
    },
    dateRegexFun(date, obj) {
      for (let key in obj) {
        // console.log(date.match(obj[key]))
        if (date.match(obj[key])) return date.match(obj[key]);
      }
    },


    toggleChecked(vo) {
      /* 拦截，至少保留一个 */
      let filterArr = this.nav.filter(vo => vo.checked)
      if (filterArr.length === 1 && vo.checked) {
        this.$myNotify.show('至少保留一个选项');
        return false
      }
      vo.checked = !vo.checked;
      this.$localStorage.setItem('navNew3', JSON.stringify(this.nav))
      if (vo.checked) {
        // this.initMonthData(`${this.currDate.year}-${this.currDate.month}`)
        this.getCalendar(vo.type)
      } else {
        this.calendarData.forEach((itm, idx) => {
          if (itm.actData.length > 0) {
            itm.actData = itm.actData.filter((item, index) => item.type != vo.type);
          }
        })
      }
    },


    // 获取指定日期的上一个月
    getPreMonth(date) {
      //判断日期常用格式的正则
      let regA = /^(\d{4})-(\d{1,2})-(\d{1,2})$/, //日期格式为：yyyy-mm-dd
        regB = /^(\d{4})年(\d{1,2})月(\d{1,2})日$/, //日期格式为：yyyy年mm月dd日
        regC = /^(\d{4})年-(\d{1,2})月-(\d{1,2})日$/, //日期格式为：yyyy年-mm月-dd日
        regD = /^(\d{4})(\d{2})(\d{2})$/, //日期格式为：yyyymmdd
        regE = /^(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy-mm-dd hh:mm:ss
        regF = /^(\d{4})年(\d{1,2})月(\d{1,2})日 (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy年mm月dd日 hh:mm:ss
        regG = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/; //日期格式为：yyyymmddhhmmss
      //判断传入的日期进行正则表达式匹配
      let arr = [];
      switch (true) {
        case regA.test(date):
        case regB.test(date):
        case regC.test(date):
        case regD.test(date):
          arr.push(RegExp.$1, RegExp.$2, RegExp.$3); //RegExp.$1获取匹配到的第一个值匹配，即‘2022’，以此类推
          console.log(arr, "arr");
          break;
        case regE.test(date):
        case regF.test(date):
        case regG.test(date):
          arr.push(
            RegExp.$1,
            RegExp.$2,
            RegExp.$3,
            RegExp.$4,
            RegExp.$5,
            RegExp.$6
          );
          console.log(arr, "arr");
          break;

        default:
          console.log("没有满足的日期格式");
          return;
      }

      arr = [...arr];
      let [year, month, day, hour, minute, second] = arr;

      let newYear = year,
        newDay = day,
        newMonth = parseInt(month) - 1;
      if (newMonth == 0) {
        newYear = parseInt(newYear) - 1;
        newMonth = 12;
      }
      let lastDays = new Date(newYear, newMonth, 0);
      lastDays = lastDays.getDate();

      newDay = newDay > lastDays ? lastDays : newDay;

      newMonth =
        newMonth < 10 && String(newMonth).length < 2 ? "0" + newMonth : newMonth;
      newDay = newDay < 10 && newDay.length < 2 ? "0" + newDay : newDay;
      minute = minute < 10 && minute.length < 2 ? "0" + minute : minute;
      second = second < 10 && second.length < 2 ? "0" + second : second;

      return arr.length > 3
        ? `${newYear}-${newMonth}-${newDay} ${hour}:${minute}:${second}`
        : `${newYear}-${newMonth}-${newDay}`;
    },

    getNextMonth(date) {
      //判断日期常用格式的正则
      let regObj = {
          regA: /^(\d{4})-(\d{1,2})-(\d{1,2})$/, //日期格式为：yyyy-mm-dd
          regB: /^(\d{4})年(\d{1,2})月(\d{1,2})日$/, //日期格式为：yyyy年mm月dd日
          regC: /^(\d{4})年-(\d{1,2})月-(\d{1,2})日$/, //日期格式为：yyyy年-mm月-dd日
          regD: /^(\d{4})(\d{2})(\d{2})$/, //日期格式为：yyyymmdd
        },
        regObj2 = {
          regE: /^(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy-mm-dd hh:mm:ss
          regF: /^(\d{4})年(\d{1,2})月(\d{1,2})日 (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy年mm月dd日 hh:mm:ss
          regG: /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, //日期格式为：yyyymmddhhmmss
        };

      //判断传入的日期进行正则表达式匹配
      let arr = [],
        valArr = [];
      //调用日期正则匹配公共方法
      if (this.dateRegexFun(date, regObj)) {
        valArr = this.dateRegexFun(date, regObj);
        arr.push(valArr[1], valArr[2], valArr[3]);
      }
      //调用日期正则匹配公共方法
      if (this.dateRegexFun(date, regObj2)) {
        valArr = this.dateRegexFun(date, regObj2);
        arr.push(valArr[1], valArr[2], valArr[3], valArr[4], valArr[5], valArr[6]);
      }

      if (arr.length === 0) return;
      arr = [...arr];
      let [year, month, day, hour, minute, second] = arr;

      let newYear = year,
        newDay = day,
        newMonth = parseInt(month) + 1;
      if (newMonth == 13) {
        newYear = parseInt(newYear) + 1;
        newMonth = 1;
      }
      let nextDays = new Date(newYear, newMonth, 0);
      nextDays = nextDays.getDate();

      newDay = newDay > nextDays ? nextDays : newDay;
      newMonth =
        newMonth < 10 && String(newMonth).length < 2 ? "0" + newMonth : newMonth;
      newDay = newDay < 10 && newDay.length < 2 ? "0" + newDay : newDay;
      minute = minute < 10 && minute.length < 2 ? "0" + minute : minute;
      second = second < 10 && second.length < 2 ? "0" + second : second;

      return arr.length > 3
        ? `${newYear}-${newMonth}-${newDay} ${hour}:${minute}:${second}`
        : `${newYear}-${newMonth}-${newDay}`;
    },

    openVip(){
      this.showNoVipModal = false;
      tag('充值:营销日历:图片')
    }


  },
}

</script>

<style lang="scss" scoped>
@import "index";
</style>
